// Copyright ©️ 2026 eVolve MEP, LLC

import type { BOMItemType } from '@evolvemep/api-ts';

import { EvolveIcon, type EvolveIconName } from 'assets/icons/EvolveIcon';

const getBomIcon = (itemType: BOMItemType): EvolveIconName | null => {
  switch (itemType) {
    case 'Part':
      return 'Part';
    case 'PC Assembly':
      return 'Assembly';
    case 'Write-In':
      return 'WriteInItem';
    case 'Spool':
      return 'Spools';
    default:
      return null;
  }
};

export const BOMItemIcon = ({ itemType }: { itemType: BOMItemType }) => (
  <EvolveIcon icon={getBomIcon(itemType)} light />
);
